export default {
  countrySelectorLabel: '',
  countrySelectorError: '',
  phoneNumberLabel: '',
  example: ''
}